import React from 'react';
import { Form} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function CustomDropdown(props) {
    return(
        <div  className="row my-3" style={{height:'100%'}}>
        <span style={{color:'#80949D'}} className="mx-3 mt-2">{props?.label}</span>
        <Form.Group controlId={props?.id}>
            <Form.Control as="select" onChange={props?.onChange}>
        {!props?.notDefaultOption &&<option>{'Select any value'}</option>}
        {props?.defaultOption && <option>{props.defaultOption}</option>}
            {props.data && props?.data.map(d=>{
                return(
                    <option key={d.value} value={d.value}>{d.key || d.value}</option>
                )
               
            })}
            </Form.Control>
        
        <Form.Text className="text-danger">
          {props.errorText}
        </Form.Text>
      </Form.Group>
      </div>
    )
}

// How to use

// <CustomDropdown 
// label="Search"
// data={[{value:0},{value:1}]}

// />

// value is required props but key is optional